import * as Sentry from "@sentry/browser";

export default class ErrorTrackingService {
    static initialize() {
        Sentry.init({
            dsn: "https://4adf37cb54733a508988078bb9bceccb@o4508772198776832.ingest.de.sentry.io/4508772236787792",
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.captureConsoleIntegration({
                    levels: ["error"],
                }),
            ],
            // Tracing
            tracesSampleRate: 1.0, //  Capture 100% of the transactions
            // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
            tracePropagationTargets: ["localhost", /^https:\/\/test\.diverselinq\.ranjgames\.com\/\S+/],
        });
    }
}